import React, {useEffect, useState} from 'react';
import {Grid, Typography} from '@mui/material';
import LocationListItemListingImage from '../../location/search/LocationImages/LocationListItemListingImage';
import ImageNotAvailablePlaceholder from '../../location/ImageNotAvailablePlaceholder';
import {styled} from "@mui/material/styles";

const Distance = styled(Typography)(() => ({
  fontSize: '1.14rem',
  fontFamily: 'Inter, sans-serif',
  fontWeight: 500,
  color: 'rgba(0, 0, 0, 0.87)',
}));

const Main = styled('div')(() => ({
  width: '100%'
}));

const LocationItem = (props) => {
  const {listingImageFileName, pricePerDay, pricePerMonth, instantApproval, locationName, cityName, distanceTo} = props;

  const [price, setPrice] = useState(0);
  const [period, setPeriod] = useState('');

  useEffect(() => {
    const pricePerDayInDollars = pricePerDay / 100;
    const pricePerMonthInDollars = pricePerMonth / 100;

    setPrice(pricePerDayInDollars === 0 ? pricePerMonthInDollars : pricePerDayInDollars);
    setPeriod(pricePerDayInDollars === 0 ? 'mon' : 'day');
  }, [pricePerDay, pricePerMonth]);

  return (
    <Main>
      {
        listingImageFileName ?
          <LocationListItemListingImage height={'11.35em'}
                                        width={'100%'}
                                        objectfit={'cover'}
                                        listingImageFileName={listingImageFileName}/> :
          <ImageNotAvailablePlaceholder height={'11.35em'}
                                        width={'100%'}
                                        objectfit={'contain'}
          />
      }

      <div className="ss-location-quick-view-item-info">
        <Grid container wrap='nowrap' justifyContent='space-between' alignItems='center'>
          <Grid item>
            {
              instantApproval ?
                <div className="ss-location-quick-view-item-approval-box instant-approval">
                  <Typography className="ss-location-quick-view-item-approval">Instant Approval</Typography>
                </div>
                :
                <div className="ss-location-quick-view-item-approval-box request-space">
                  <Typography className="ss-location-quick-view-item-approval">Request Space</Typography>
                </div>
            }
          </Grid>
          {distanceTo && <Distance>
            {distanceTo} mi
          </Distance>}
        </Grid>
        <Typography className="ss-location-quick-view-item-price" color="textPrimary">${price}<strong
          className="ss-location-quick-view-item-price-units">/{period}</strong></Typography>
        <Typography variant="h5" noWrap={true} color={'secondary'}
                    className={"ss-location-quick-view-item-title"}>{locationName}</Typography>
        <Typography variant="body2" className="ss-location-quick-view-item-city">USA, {cityName}</Typography>
      </div>
    </Main>
  )
}

export default LocationItem;
